module.exports = __webpack_public_path__ + "static/img/16.26c555b2.jpeg";